declare global {
  interface Window {
    SAM?: Record<string, unknown>;
    _env?: Record<string, unknown>;
  }
}

const hasDebugParam = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get('debug') === 'true';
};

const ensureDebugStore = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!window.SAM) {
    window.SAM = { name: 'SAM Debug Assistance' };
  }

  return window.SAM;
};

export function attachToDebug(name: string, value: unknown) {
  if (!hasDebugParam()) {
    return;
  }

  const store = ensureDebugStore();
  if (!store) {
    return;
  }

  store[name] = value;
}
